export function calculateAutomationStats(activeAutomations) {
  const totaleUtilizzi = activeAutomations.reduce((sum, item) => sum + item.utilizziTotali, 0);
  const tempoTotaleRisparmiato = activeAutomations.reduce(
    (sum, item) => sum + item.utilizziTotali * item.tempoMedioRisparmiato,
    0
  );
  const costoTotale = activeAutomations.reduce((sum, item) => sum + item.costoMensile, 0);

  return {
    totaleUtilizzi,
    tempoRisparmiatoOre: Math.floor(tempoTotaleRisparmiato / 60),
    tempoRisparmiatoMinuti: tempoTotaleRisparmiato % 60,
    costoTotale,
  };
}

export function formatAutomationDateTime(dateString) {
  return new Date(dateString).toLocaleString('it-IT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getAutomationRenewalDate() {
  const expirationDate = new Date();
  expirationDate.setMonth(expirationDate.getMonth() + 3);

  return expirationDate.toLocaleDateString('it-IT', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}

export function getAutomationTotalSavedTime(automation) {
  const totalMinutes = automation.utilizziTotali * automation.tempoMedioRisparmiato;

  return {
    hours: Math.floor(totalMinutes / 60),
    minutes: totalMinutes % 60,
  };
}
